import {z} from "zod";

export const variantSchema = z.object({
    title: z.string().min(1, "Variant title is required"),
    price: z.number().positive("Price must be greater than 0"),
    quantity: z.number().int().nonnegative("Quantity must be 0 or greater"),
    image: z.array(z.url("Each image must be a valid URL")).optional(),
});

const optionSchema = z.object({
    name: z.string().min(1),
    values: z.array(z.string().min(1)),
});

export const productSchema = z.object({
    image: z.array(z.url("Image must be a valid URL")),
    alttext: z.string().trim().min(1, "Alt text is required"),
    title: z.string().trim().min(1, "Title is required").regex(/^[\w\s,.!'()+?|\\:;/×-]+$/, "Invalid characters in title"),
    description: z.string().trim().min(1, "Description is required"),
    details: z.array(z.string()).optional(),
    isFeatured: z.boolean(),
    price: z.number().min(10, "Price must be greater than 10"),
    sku: z.string().trim().min(1, "SKU is required"),
    variants: z.array(variantSchema).optional(),
    supplier: z.string().trim().min(1, "Supplier is required"),
    quantity: z.coerce.number().int().positive("Quantity must be greater than 0"),
    tags: z.array(z.string()).optional(),
    categorizations: z.array(
        z.object({
            category: z.string().regex(/^[\w\s$:,;-]+$/, "Invalid category"),
            subcategory: z.string().regex(/^[\w\s$:,;-]+$/, "Invalid subcategory"),
        })
    ).min(1, "At least one categorization is required"),
    priority: z.number().int().nullable(),
    options: z.array(optionSchema).optional().nullable(),
    googleDisplay: z.boolean().nullable().optional(),
    googleProductCategory: z.string().min(1).optional().nullable(),
    productType: z.string().min(1).optional().nullable(),
    daysToHoliday: z.coerce.number().int("Expecting positive integer").positive("Days to holiday must be greater then 0").nullable().optional(),
    newProduct: z.boolean(),
    sizeChart: z.array(z.array(z.string())).nullable().optional(),
});
